"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreConfirmReducer = exports.coreConfirmActions = exports.TYPES_CONFIRM = void 0;
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_CONFIRM = 'coreConfirm';
const TYPES_CONFIRM = exports.TYPES_CONFIRM = {
  OPEN: CORE_CONFIRM + 'Open',
  CLOSE: CORE_CONFIRM + 'Close'
};
const INIT_STATE = {
  title: '',
  message: '',
  isOpen: false,
  width: null,
  onClickOk: () => {}
};
const coreConfirmActions = exports.coreConfirmActions = (0, _reduxActions.createActions)({
  [TYPES_CONFIRM.OPEN]: function () {
    return {
      title: arguments.length <= 0 ? undefined : arguments[0],
      message: arguments.length <= 1 ? undefined : arguments[1],
      onClickOk: arguments.length <= 2 ? undefined : arguments[2],
      width: arguments.length === 4 ? arguments.length <= 3 ? undefined : arguments[3] : null
    };
  }
}, TYPES_CONFIRM.CLOSE);
const coreConfirmReducer = exports.coreConfirmReducer = (0, _reduxActions.handleActions)({
  [TYPES_CONFIRM.OPEN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      title: action.payload.title,
      message: action.payload.message,
      onClickOk: action.payload.onClickOk,
      isOpen: true,
      width: 'width' in action.payload ? action.payload.width : null
    });
  },
  [TYPES_CONFIRM.CLOSE]: state => {
    return _objectSpread(_objectSpread({}, INIT_STATE), {}, {
      title: state.title,
      message: state.message,
      width: state.width
    });
  }
}, INIT_STATE);